module.exports = __webpack_public_path__ + "img/lucasfalsarellaguerreiro_fun.8c7d5034.jpg";